import { Input, Label, TextArea, TextField as AriaTextField, type TextFieldProps } from "react-aria-components";
import { twMerge } from "@/lib/twMerge";
import { FIELD_STYLES } from "@/lib/fieldStyles";

interface Props extends TextFieldProps {
  label?: string;
  placeholder?: string;
  multiline?: boolean;
  rows?: number;
  className?: string;
}

/** A labelled single-line input, or a textarea with `multiline` (the Map page's product
 * description). React Aria handles the label/input association; styling is the shared
 * FIELD_STYLES so it matches Select. */
export function TextField({ label, placeholder, multiline, rows = 4, className, ...props }: Props) {
  return (
    <AriaTextField {...props} className={twMerge("flex flex-col gap-[5px]", className)}>
      {label && <Label className="text-xs text-text/70">{label}</Label>}
      {multiline ? (
        <TextArea rows={rows} placeholder={placeholder} className={twMerge(FIELD_STYLES, "leading-relaxed")} />
      ) : (
        <Input placeholder={placeholder} className={FIELD_STYLES} />
      )}
    </AriaTextField>
  );
}
